/**
 * External dependencies
 */
import {
	withBlockStyles,
	withSetAttributeHook,
	withTabbedInspector,
	withUniqueClass,
	withClickOpenInspector,
} from '~cartzillagb/higher-order'

// import {
// 	appendImportant,
// } from '~cartzillagb/util'

import {
	BlockContainer,
	BackgroundSettings,
	ResponsiveControl,
	AdvancedRangeControl,
	ImageUploadPlaceholder,
	URLInputControl,
} from '~cartzillagb/components'

import { i18n } from 'cartzillagb'
import classnames from 'classnames'
import createStyles from './style'
import $ from 'jquery'

import './common'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
	Fragment,
	useRef,
	useEffect
} from '@wordpress/element'
import {
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import {
	InnerBlocks,
	RichText
} from '@wordpress/block-editor'
import {
	PanelBody,
	ToggleControl,
} from '@wordpress/components'
import { 
	withDispatch
} from '@wordpress/data'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.banner-with-products-carousel.edit.inspector.style.before', 'cartzillagb/banner-with-products-carousel', ( output, props ) => {
	const {
		attributes,
		setAttributes
	} = props
	const {
		enableContainer,
		bannerAlignRight,
		bannerLinkURL,

		bgColor,
		customBgColor,
		enableImage,

		infinite,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Carousel Options", i18n ) } initialOpen={ true }>
				<ResponsiveControl
					attrNameTemplate="slidesPerRow%s"
					setAttributes={ setAttributes }
					blockAttributes={ attributes }
					screens={ [ 'desktop', 'tablet' ] }
				>
					<AdvancedRangeControl
						label={ __( 'Slides To Show', i18n ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.banner-with-products-carousel.edit.inspector.max.slidesToShow', 8 ) }

					/>
				</ResponsiveControl>
				<ToggleControl
					label={ __( 'Enable Infinite Scroll', i18n ) }
					checked={ infinite }
					onChange={ infinite => setAttributes( { infinite } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( 'Banner Settings', i18n ) } initialOpen={ false }>
				<BackgroundSettings
					background={ bgColor }
					backgroundColor={ customBgColor }
					onChangeBackground={ bgColor => setAttributes( { bgColor } ) }
					onChangeBackgroundColor={ customBgColor => setAttributes( { customBgColor: customBgColor.hex } ) }
					onRemoveBackground={ () => { setAttributes( { bgColor: '', customBgColor: '' } ) } }
				/>
				<URLInputControl
					label={ __( 'Banner URL', i18n ) }
					value={ bannerLinkURL }
					onChange={ bannerLinkURL => setAttributes( { bannerLinkURL } ) }
				/>
				<ToggleControl
					label={ __( 'Banner Align Right', i18n ) }
					checked={ bannerAlignRight }
					onChange={ bannerAlignRight => setAttributes( { bannerAlignRight } ) }
				/>
				<ToggleControl
					label={ __( 'Display Banner Image', i18n ) }
					checked={ enableImage }
					onChange={ enableImage => setAttributes( { enableImage } ) }
				/>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const {
		className,
		attributes,
		setAttributes,
		updateColumns,
		clientId,
	} = props
 
	const {
		blockId,
		enableContainer,
		bannerTitle,
		bannerLinkText,
		bannerAlignRight,
		enableImage,
		mediaURL,

		bgColor,
		customBgColor,

		// Carousel Options
		slidesPerRow,
		slidesPerRowTablet,
		infinite,
	} = attributes

	const slickEl = useRef( blockId || clientId )

	useEffect( () => {
		updateColumns( slidesPerRow )
	}, [
		slidesPerRow,
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-banner-with-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				const slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-banner-with-products-carousel' ).attr( 'data-slick-attributes' ) )
				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'slidesPerRow': attributes.slidesPerRow,
					'responsive': [
						{
							breakpoint: 991.98,
							settings: {
								slidesPerRow: slidesPerRowTablet,
							}
						},
					],
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateDots' )
				$( slickEl.current ).find( '.products' ).slick( 'updateArrows' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		slidesPerRow,
		slidesPerRowTablet
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-banner-with-products-carousel' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				const slickAttributes = JSON.parse( $( slickEl.current ).closest( '.wp-block-czgb-banner-with-products-carousel' ).attr( 'data-slick-attributes' ) )

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'infinite': attributes.infinite,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		infinite
	] )

	const mainClasses = classnames( [
		'mb-4',
		'pb-3',
		'pb-sm-0',
		'mb-sm-5',
		className,
		enableContainer ? 'container' : '',
	], applyFilters( 'cartzillagb.banner-with-products-carousel.main-block.classes', {}, props ) )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.banner-with-products-carousel.main-block.classes', {
		slidesPerRow: 3,
		slidesToScroll: 1,
		rows: 2,
		dots: false,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 991.98,
				settings: {
					slidesPerRow: 2,
				}
			},
		],
	}, props )

	let carouselOptions = {
		rows: 2,
		slidesPerRow: attributes.slidesPerRow,
		responsive: [
			{
				breakpoint: 991.98,
				settings: {
					slidesPerRow: slidesPerRowTablet,
				}
			},
		],
	}

	const blockAttributes = { ...attributes }

	if( infinite === false ) {
		carouselOptions.infinite = false
	} else {
		delete blockAttributes.infinite
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const sliderWraperAttr = {}

	sliderWraperAttr.className = classnames( [
		'cz-carousel',
		'cz-controls-static',
	] )

	const bgStyle = { backgroundColor: customBgColor && customBgColor }

	const setBlockId = blockId => setAttributes({ blockId })

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	return (
		<BlockContainer.Edit className={ mainClasses } blockProps={ { ...props, attributes:{ ...blockAttributes, anchor: blockId !== undefined ? blockId : clientId } } } data-slick-classes="js-slick-carousel" data-slick-attributes={ JSON.stringify( carouselOptions ) } render={ () => (
			<div className={ 'row' }>
				<div className={ `col-md-5${ bannerAlignRight ? ' order-md-2' : '' }` }>
					<div className={ `d-flex flex-column h-100 overflow-hidden rounded-lg ${ customBgColor ? '' : ( bgColor ? bgColor : 'bg-secondary' ) }` } style={ bgStyle }>
						<div className={ `d-flex justify-content-between px-grid-gutter py-grid-gutter` }>
							<div className={ `banner-text${ bannerAlignRight ? ' order-md-2' : '' }` }>
								<RichText
									tagName="h3"
									className="mb-1"
									value={ bannerTitle }
									onChange={ bannerTitle => setAttributes( { bannerTitle } ) }
									placeholder={ __( 'Banner Title', i18n ) }
									keepPlaceholderOnFocus
								/>
								<RichText
									tagName="a"
									className="banner-link-text font-size-md"
									value={ bannerLinkText }
									onChange={ bannerLinkText => setAttributes( { bannerLinkText } ) }
									placeholder={ __( 'Banner Link Text', i18n ) }
									keepPlaceholderOnFocus
								/>
								<i className="czi-arrow-right font-size-xs align-middle ml-1"></i>
							</div>
							<div className={ 'cz-custom-controls' }></div>
						</div>
						{ enableImage &&
							<a href={ true } className="d-none d-md-block mt-auto banner-text">
								<ImageUploadPlaceholder
									imageURL={ mediaURL }
									onRemove={ () => {
										setAttributes( {
											mediaURL: '',
										} )
									} }
									onChange={ ( { url } ) => {
										setAttributes( {
											mediaURL: url,
										} )
									} }
									hasRemove={ false }
									render={ <img src={ mediaURL } className={ `d-block w-100` } alt={ __( 'Banner Image', i18n ) } /> }
								/>
							</a>
						}
					</div>
				</div>
				<div className={ 'col-md-7 pt-4 pt-md-0' }>
					<div ref={ slickEl } { ...sliderWraperAttr }>
						<InnerBlocks
							template={
								[ 
									[ 'czgb/products', {
										columns: 3,
										limit: 12,
										placeholder: 6,
										exclude: [ 'columns' ]
									} ]
								]
							}
							templateLock="all"
						/>
					</div>
				</div>
			</div>
		) } />
	)
}

export default compose(
	withUniqueClass,
	withSetAttributeHook,
	withTabbedInspector( [ 'style', 'advanced' ] ),
	withBlockStyles( createStyles, { editorMode: true } ),
	withClickOpenInspector( [
		[ '.czgb-products-carousel__title', 'title' ],
	] ),
	withDispatch( ( dispatch, ownProps, { select } ) => {
		return {
			updateColumns( slidesPerRow ) {
				const { clientId } = ownProps
				const { getBlockOrder } = select( 'core/block-editor' )
				const { updateBlockAttributes } = dispatch( 'core/block-editor' )
				const innerBlockIds = getBlockOrder( clientId )

				innerBlockIds.forEach( innerBlockId => {
					updateBlockAttributes( innerBlockId, {
						columns: slidesPerRow || 3,
						placeholder: slidesPerRow * 2 || 6,
					} )
				} )
			}
		}
	} ),
)( edit )